import C from './constants'

//Import utility functions
import {    makeUserPalette,
            makeColorArrayNew, updateColorArr, 
            copyTextToClipboard,
            downloadCsv, downloadJson, downloadArr, downloadJpeg, downloadViz} from '../data/utilFunc'


// Final Reducers
export const chartSelected = (state = "", action) => {
    switch (action.type) {
        case C.CHANGE_VIZ:
            return action.chartSelected
        default :
            return state
    }
}

export const theme = (state = "", action) => {
    let theme  = action.theme 
    let userWindow = action.userWindow
    theme = theme === 'dark'?'light':'dark'    
    switch (action.type) {
        case C.CHANGE_THEME:
            document.body.style.backgroundColor = theme === 'dark'?userWindow.lightColor:userWindow.darkColor
            return theme
        default :
            return state
    }
}

export const simDisplay = (state = false, action) => {
    switch (action.type) {
        case C.SIMULATE:
            return !action.simDisplay
        default :
            return state
    }
}

export const colorArr = (state = [], action) => {
    let colorArr = state;
    let id = action.id;
    let selected = action.selected;
    let randomIdsObj = action.randomIdsObj
    let colorRowId = action.colorRowId;
    let startHex = action.startHex;
    let endHex = action.endHex;
    let userWindow = action.userWindow;
    let selectAll = action.selectAll;
    switch (action.type) {
        case C.UPDATE_PALETTE:
            colorArr = colorArr.map((colorRowObj) => 
                            ({
                                ...colorRowObj,
                                colorArr: colorRowObj.colorArr.map((color) =>  
                                    (color.id !== id) ?
                                    color :
                                    {
                                        ...color,
                                        selected: !selected
                                    })
                                }
                            ))
            return colorArr
        case C.TRASH_ALL:
            colorArr = colorArr.map((colorRowObj) => 
                            ({
                                ...colorRowObj,
                                selectAll: false,
                                colorArr: colorRowObj.colorArr.map((color) =>  
                                    ({
                                        ...color,
                                        selected: false
                                    }))
                                }
                            ))
            return colorArr
        case C.RANDOMIZE_COLORS:
            let randomIds = randomIdsObj.map((d) => d.id)
            colorArr = colorArr.map((colorRowObj) => 
                            ({
                                ...colorRowObj,
                                selectAll: false,
                                colorArr: colorRowObj.colorArr.map((color) =>  
                                    randomIds.includes(color.id) ?
                                    {
                                        ...color,
                                        selected: true
                                    }:
                                    {
                                        ...color,
                                        selected: false
                                    }
                                )
                                }
                            ))
            return colorArr
        case C.REMOVE_PALETTE:
            colorArr = colorArr.filter((colorRowObj) => colorRowObj.colorRowId !== colorRowId)
            return colorArr
        case C.SELECT_ALL_COLORS:
            colorArr = colorArr.map((colorRowObj) => 
            
                colorRowObj.colorRowId !== colorRowId
                ?
                {...colorRowObj}
                :
                (
                    {
                    ...colorRowObj,
                    selectAll: !selectAll,
                    colorArr: colorRowObj.colorArr.map((color) =>  
                            ({
                                ...color,
                                selected: !selectAll
                            }))
                    }
                )
            )
            return colorArr
        case C.ADD_COLOR_PALETTE:
            let colorArrNew = makeColorArrayNew(startHex, endHex, userWindow);
            colorArr = [colorArrNew, ...colorArr]
            return colorArr
        case C.SUBTRACT_COLOR_PALETTE:
            let [firstArr, ...remaining] = colorArr;
            return remaining
        case C.UPDATE_COLOR_ATTR:
            let colorArrUpdated = updateColorArr(state, userWindow)
            return colorArrUpdated;
        default :
            return state
    }
}

export const userPalette = (state = [], action) => {
    let id = action.id;
    let selected = action.selected;
    let color = action.color;
    let userWindow = action.userWindow;
    let userPalette = state.flat() //flatten the array
    let randomIdsObj = action.randomIdsObj
    let colorArr = action.colorArr
    let colorRowId = action.colorRowId
    let selectAll = action.selectAll
    switch (action.type) {
        case C.UPDATE_PALETTE:
            //based on the user selection
            selected
            ?
            userPalette = userPalette.filter(color => color.id !== id):
            userPalette = [...userPalette,
              {
                  id,
                  color,
                  selected: true
              }]
            userPalette = makeUserPalette(userPalette, userWindow)
            return userPalette
        case C.TRASH_ALL:
            return []
        case C.RANDOMIZE_COLORS:
            userPalette = randomIdsObj.map((d) => ({...d, selected: true}))
            userPalette = makeUserPalette(userPalette, userWindow)
            return userPalette
        case C.SELECT_ALL_COLORS:
            //updating colorArr
            colorArr = colorArr.filter((colorRowObj) => colorRowObj.colorRowId == colorRowId)
            colorArr = colorArr.map((colorRowObj) => colorRowObj.colorArr.map((color) => ({...color, selected: true})))
            colorArr = colorArr.flat()
            let colorArrIds = colorArr.map((color) => color.id)

            //updating userPalette
            userPalette = userPalette.flat()
            userPalette = userPalette.filter((color) => !colorArrIds.includes(color.id))

            !selectAll
            ?
            userPalette = [...userPalette, ...colorArr]
            :
            userPalette = userPalette.flat().filter((color) => !colorArrIds.includes(color.id))
            console.log(userPalette)
            userPalette = makeUserPalette(userPalette, userWindow)
            return userPalette
        case C.UPDATE_COLOR_ATTR:
            userPalette = makeUserPalette(userPalette, userWindow)
            return userPalette
        default :
            return state
    }
}

export const userWindow = (state = [], {type, colorClicked, currUserPalette, 
                                        currTheme, currChartSelected,
                                        imgFormat}) => {
    let userWindow = state;
    // let colorClicked = action.colorClicked
    switch (type) {
        case C.CHANGE_MEDIA:
            let padding = (userWindow.circleCount+1)*10
            let colorHolderEle = document.getElementById('colorHolder').offsetWidth
            let docWidth = document.body.clientWidth;
            let docHeight = document.body.clientHeight;
            let maxHeight = docWidth>=575?465:230
            let rowHeight = docWidth>=575?80:65
            let rowWidth = colorHolderEle-8
            let radius = ((rowWidth-padding)/20)-3;
            let radiusSelected = radius + 5;
            let selectX = 0.75*colorHolderEle;
            let removeX = 0.25*colorHolderEle;
            let removeY = (userWindow.colorSpace*rowHeight) + ((userWindow.textSpace*rowHeight)/2);
            let selectY = (userWindow.colorSpace*rowHeight) + ((userWindow.textSpace*rowHeight)/2);
            let fontSize = docWidth>=575?12:10 
            let vizHolderWidth = document.getElementById('vizHolder').offsetWidth           
            userWindow = {...userWindow, 
                            docHeight,
                            docWidth,
                            maxHeight,
                            vizHolderWidth,
                            radius, 
                            radiusSelected,
                            rowHeight,
                            rowWidth,
                            selectX,
                            selectY,
                            removeX,
                            removeY,
                            fontSize}
            return userWindow
        case C.COPY_COLOR_TO_CLIPBOARD:
            copyTextToClipboard(colorClicked)
            userWindow = {...userWindow,
                        colorClicked}
            return userWindow
        case C.DOWNLOAD_CSV:
            userWindow = {...userWindow,
                            downloadsCsv: userWindow.downloadsCsv+1}
            downloadCsv(currUserPalette)
            return userWindow
        case C.DOWNLOAD_JSON:
            userWindow = {...userWindow,
                            downloadsJson: userWindow.downloadsJson+1}
            downloadJson(currUserPalette);
            return userWindow
        case C.DOWNLOAD_ARR:
            userWindow = {...userWindow,
                            downloadsJson: userWindow.downloadsJson+1}
            downloadArr(currUserPalette);
            return userWindow
        case C.DOWNLOAD_JPEG:
            userWindow = {...userWindow,
                            downloadsJpeg: userWindow.downloadsJpeg+1}
            downloadJpeg(currUserPalette, userWindow, currTheme);
            return userWindow  
        case C.DOWNLOAD_VIZ:
            downloadViz(userWindow, currTheme, currChartSelected, imgFormat)
            return userWindow
        default :
            return state
    }
}
